import * as React from 'react';
import { DonationManagentList } from '../util';
import { withTranslation } from 'react-i18next';

const DonorListComponent = (props: any) => {
  const { t } = props;

  return (
    <section className="no_color_change ">
      <div className="aw_container aw_text_block_module pt48 pb48 pt_mobile_32 left">
        <div className="aw_row no_row_gap">
          <div className="col_12">
            <h5 className="h5 dark aw_8col_text">{t('question_headline')}</h5>
          </div>
        </div>
        <div className="aw_row no_row_gap">
          <div className="col_3"></div>
          <div className="col_9 left dark">
            <ul className="aw_checkmark_list aw_plarge" style={{ marginLeft: '30px' }}>
              {DonationManagentList?.map(({ id, value }: any) => {
                return (
                  <li className="menu-item" key={id}>
                    <p>{value[t('language')]}</p>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withTranslation('language')(DonorListComponent);
